
	const texts = {
		mge: {
			empty_agenda_text: customData.i18n.empty_agenda_text,
         empty_agenda_subtext: customData.i18n.empty_agenda_subtext,
         agenda_date_today: customData.i18n.agenda_date_today,
         agenda_date_tomorrow: customData.i18n.agenda_date_tomorrow,
         agenda_date_all: customData.i18n.agenda_date_all,
         agenda_date_choose: customData.i18n.agenda_date_choose,

         agenda_dropdown_more_genres: customData.i18n.agenda_dropdown_more_genres,
         agenda_dropdown_all_genres: customData.i18n.agenda_dropdown_all_genres,
         agenda_tab_all_events: customData.i18n.agenda_tab_all_events,
         agenda_tab_series: customData.i18n.agenda_tab_series,
         agenda_tab_just_confirmed: customData.i18n.agenda_tab_just_confirmed,

         agenda_results_single: customData.i18n.agenda_results_single,
         agenda_results: customData.i18n.agenda_results,
         agenda_tile_from: customData.i18n.agenda_tile_from,
         agenda_tile_info: customData.i18n.agenda_tile_info,
         agenda_show_soldout: customData.i18n.agenda_show_soldout,
			agenda_date_this_weekend: customData.i18n.agenda_date_this_weekend,
			agenda_date_this_week: customData.i18n.agenda_date_this_week,
			agenda_empty_filter: customData.i18n.agenda_empty_filter,
		},
	}

	window.customData.childTheme = 'mge'; //SET THIS
	window.customData.i18n = texts[window.customData.childTheme];

/**
* Contains React app configuration for each child

* Main configuration:
* @param {string} name - the display name of the child
* @param {string} theme - slug for child theme
* @param {Boolean} multiLanguage - using eng/dutch (true) or only dutch (false)
* @param {Boolean} hide_on_home_desktop - by default this app shows on homepage, but most sites hide this on desktop
* @param {String} empty_agenda_text - text that is shown on empty state
* @param {String} loading_svg - name of svg used for loader ("Camera"/"KinoLoader" or null)

* Movie tile configuration
* @param {Boolean/String} showtime_undertitle - in movie tile, what is displayed underneath each show time (e.g. venue, room) or false for nothing
* @param {String} card_type - choose between two different designs, either "filmhallen" or "bioscopenleiden"
* @param {String} agenda_tile_type - choose between different designs: "small", "big", or "both" (for variation according to sort option)
* @param {String} big_title_agendatext - choose between "storyline" or "synopsis" (or null if no big tile)
* @param {Boolean} big_tile_date_short - use specific date view that only displays first letters of month/weekday (if in big tile)
* @param {Boolean} show_movie_info_in_tile - show director name, country, duration (if in big tile)
* @param {Boolean} show_movie_review_in_tile - show review (if in big tile)
* @param {Boolean} year_in_tile - show year in date display
* @param {Number} promo_cards_frequency - if set, this indicates the frequency of rendering promotion tiles in the array of agenda tiles
* @param {Boolean} date_today_tomorrow_label - show "vandaag" and "morgen" labels instead of dates in case of today/tomorrow

* Filterbar configuration
* @param {Boolean} has_cinema_selector - in case of multiple locations/cinemas for one site, this feature can filter out specific cinema
* @param {Boolean} has_sorting_option - feature to manually switch/toggle between showing 1) movies sorted by popularity or 2) individual showtimes
* @param {Boolean} sorting_option_mobile_nonemodal - option for a second sorting toggle above filterbar on closed modal
* @param {Number} minimum_days_in_filter - amount of fixed days that are shown in dropdown even if they do not match a show
* @param {Array} no_special_tags - showtags from db that are excluded when finding "specials"
* @param {Array} tags_hide_from_dropdown - which tags are available for tiles but not for filter dropdown
* @param {Boolean} date_filter_range - true when date filtering goes by ranges more than one day (e.g. week, month, May, October '23, etc)
* @param {Boolean} results_beyond_date - true when all future events are shown beyond the selected date (from this date onwards)
* @param {Boolean} date_presets - true when preset options need to be added to time filter ("Deze week", "Volgende maand", etc)
* @param {Boolean} shows_tags_as_labels

* Tab configuration
* @param {Object} available_tabs - Object with tabs for this site featuring {slug: title} of the tab
* @param {String} special_tab_sorting - sort special tab movies by either "release-date" or popularity ("populair" )
* @param {String} special_tab_filtering - show all specials ("all-specials") or only those with showtimes ("only-with-times")

*/
const config = {
	name: 'Muziekgebouw Eindhoven',
	theme: 'mge',
	multiLanguage: true,
	empty_agenda_text: customData.i18n.empty_agenda_text,
	empty_agenda_subtext: customData.i18n.empty_agenda_subtext,
	empty_agenda_button: customData.i18n.empty_agenda_button,
	showtime_undertitle: false,
	has_sorting_option: false,
	sorting_option_mobile_nonemodal: false,
	minimum_days_in_filter: 0,
	date_filter_range: true,
	date_presets: [
		{ 'today': customData.i18n.agenda_date_today },
		{ 'this weekend': customData.i18n.agenda_date_this_weekend },
		{ 'this week': customData.i18n.agenda_date_this_week },
	],
	results_beyond_date: true,
	year_in_tile: true,
	promo_cards_frequency: 7,
	no_special_tags: [],
	tags_hide_from_dropdown: [],
	available_tabs: {
		all_events: customData.i18n.agenda_tab_all_events,
		series: customData.i18n.agenda_tab_series,
		just_confirmed: customData.i18n.agenda_tab_just_confirmed,
	},
	special_tab_sorting: "release-date",
	special_tab_filtering: "only-with-times",
	shows_tags_as_labels: false,
	show_filter_reset: true,
	pagination_pagesize: 20,
	date_today_tomorrow_label: false,
};

export default config;
